import React, { useContext,useState,useEffect } from 'react';
import { Box, StepLabel, Stepper, Step } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Button, Link, Notification, LoadingSpinner } from '@lmig/lmds-react';
import { FormContext } from '../FormContext/FormContext';
import Details from '../Pages/Details';
import UploadDocument from '../Pages/UploadDocument';
import Review from '../Pages/Review';
import { STEP_NAMES } from '../constants';
import WelcomePage from '../Pages/WelcomePage';
import Contractor from '../Pages/Contractor';
// import SupplementType from '../Pages/SupplementType';
import Confirmation from '../Pages/Confirmation';



const steps = [
  STEP_NAMES.STEP_ONE.label,
  STEP_NAMES.STEP_TWO.label,
  // STEP_NAMES.STEP_THREE.label,
  STEP_NAMES.STEP_FOUR.label,
  STEP_NAMES.STEP_FIVE.label,
  STEP_NAMES.STEP_SIX.label
];

const StyledStepperLabel = styled(Stepper)({
  ['@media (max-width: 720px)']: {
    '& .MuiStep-alternativeLabel:last-child .MuiStepConnector-root': {
      left: 'calc(-50% + -6px)'
    },
    '& .MuiStep-alternativeLabel:nth-of-type(2) .MuiStepConnector-root': {
      left: 'calc(-50% + 42px)'
    }
  }
});
const pages = [
  <Details key={0} />,
  <Contractor key={1} />,
  // <SupplementType key={2} />,
  <UploadDocument key={2} />,
  <UploadDocument key={3} />,
  <Review key={4} />
];

const StyledStepLabel = styled(StepLabel)({
  '& .MuiStepIcon-root': {
    color: '#9D9E9E',
    '&.Mui-active': {
      color: '#28A3AF'
    },
    '&.Mui-completed': {
      color: '#28A3AF'
    }
  }
});



const Controller = () => {
  const [values, handleSetValues, , canContinue] = useContext(FormContext);
  const isFinalStep = values.activeStep === steps.length - 1;
 const stepperContainerRef = React.useRef(null);

// Track window width for responsive IconButton
 
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Box sx={{ width: '100%', paddingTop: '1.25rem' }}>

      {values.showPersonaModal === false && values.activeStep >= 0 && values.activeStep < 5 && (
        <Link
          style={{ marginLeft: '20px', marginTop: windowWidth < 720 ? '4px' : '28px',
                   marginBottom: windowWidth < 720 ? '16px' : '32px' }}
          caretPosition='left'
          variant='standalone'
          disabled={values.showPersonaModal === true}
          onClick={(e) => handleSetValues('activeStep', e)}
        >
          Back
        </Link>
      )}
        {(values.activeStep === 2 || values.activeStep === 3) && (values.uploads.minFileSizeError 
          || values.uploads.maxFileSizeError || values.uploads.maxTotalFileSizeError || !!values.uploads.invalidSupplementsError
        ) && <div style={{
        marginTop: '24px',
        marginBottom: '32px'

      }}>
        {(values.activeStep === 2 || values.activeStep === 3) && values.uploads.minFileSizeError && (
          <Notification
            alert=" The above files have failed to be read or are below 450 bytes in size. Please try again."
            highlightType="negative"
            style={{

              marginBottom: '8px'
            }}
          />
        )}
        {(values.activeStep === 2 || values.activeStep === 3) && values.uploads.maxFileSizeError && (
          <Notification
            alert="The file you uploaded exceeds the 10MB size limit. Please upload a smaller file."

            highlightType="negative"
            style={{

              marginBottom: '8px'
            }}
          />
        )}
        {(values.activeStep === 2 || values.activeStep === 3) && values.uploads.maxTotalFileSizeError && (
          <Notification
            alert="The files you uploaded exceed the 100 MB total size limit. Please upload fewer or smaller files."
            highlightType="negative"
            style={{

              marginBottom: '8px'
            }}
          />
        )}
        {(values.activeStep === 2 || values.activeStep === 3) && (!!values.uploads.invalidSupplementsError)
          && (
            <Notification
              alert="The file type you uploaded is not allowed.  Please upload a file type listed in the requirements below."
              highlightType="negative"
              style={{
                marginTop: '24px'
              }}
            />
          )}
      </div>
}
      {!values.showPersonaModal && (values.submitProgress !== 'success' && values.submitProgress !== 'submitting') && <div>
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        <div

         ref={stepperContainerRef}
  style={{
    width: '100%',
    overflowX: 'auto',
    minHeight: '72px',
    ...(window.innerWidth < 720 && { maxWidth: '720px', whiteSpace: 'nowrap' })
  }}
>
        <StyledStepperLabel activeStep={values.activeStep} 
        alternativeLabel style={{ width: '100%',  
         ...(windowWidth < 720 && { marginLeft: '0px' }), ...(windowWidth > 720 && { marginLeft: '-45px' }) }}>
       
          {steps.map((label) => {
            const stepProps = {};
            return (
              <Step key={label} {...stepProps} >
                <StyledStepLabel>
                  {values.isContractor && label === 'Contractor info' ? 'Business Details' : label}
                </StyledStepLabel>
              </Step>
            );
          })}
        
       
        </StyledStepperLabel>
        </div>
   
        </div>

          {pages[values.activeStep]}
          <Box style={{ padding: '0px 35px 0px 0px' }}>
            <style>
              {`
            /* Desktop */
            .continue-btn {
              margin-left: 20px;
            }
            /* Mobile */
            @media (max-width: 600px) {
              .continue-btn {
              }
            }
            `}
            </style>
            {values.activeStep < 5 && (
              <Button
                className='continue-btn'
                size='large'
                type='submit'
                variant='primary'
                disabled={!canContinue}
                onClick={(e) => handleSetValues('activeStep', e)}
              >
                {isFinalStep ? 'Submit' : 'Continue'}
              </Button>
            )}
          </Box>
        </div>}

        {values.showPersonaModal &&
          <WelcomePage />}
        {(values.submitProgress === 'submitting') &&
          <div><LoadingSpinner color="blue" /> Submitting...</div>}
        {values.submitProgress === 'success' &&
          <Confirmation />}
      </Box>
  );
};

      export default Controller;
